import { serialize, parse } from "cookie";
import config from "@/lib/config";

export default class Cookies {
  constructor(req, res) {
    this.req = req;
    this.res = res;
  }

  set(values) {
    if (!(values instanceof Array)) {
      values = [values];
    }
    const existsCookies = this.res.getHeader("Set-Cookie") ?? [];
    const cookies = Array.from(values).map(({ name, value, options = {} }) => {
      return serialize(
        name,
        value,
        Object.assign({}, config.cookieOptions, options)
      );
    });
    this.res.setHeader("Set-Cookie", [...existsCookies, ...cookies]);
  }

  remove(names) {
    if (!(names instanceof Array)) {
      names = [names];
    }
    this.set(
      Array.from(names).map((name) => {
        if (name instanceof Array) {
          return {
            name: name[0],
            value: "",
            options: Object.assign({ maxAge: 0 }, name[1]),
          };
        } else {
          return {
            name,
            value: "",
            options: { maxAge: 0 },
          };
        }
      })
    );
  }

  get(name) {
    const cookies = this.parse();
    return cookies[name];
  }

  parse() {
    if (this.req.cookies) return this.req.cookies;

    const cookie = this.req.headers?.cookie;
    return parse(cookie || "");
  }
}
